/**
 * Form
 * @version 3.0.0
 */

function openAllForms() {
  const inputs = document.querySelectorAll(".js-form-overlay .rt-form__input");
  inputs.forEach((input) => {
    if (input.value.length > 0) {
      input.closest(".js-form-overlay").classList.add("is-active");
    } else {
      input.closest(".js-form-overlay").classList.remove("is-active");
    }
  });
}

function openFormOnFocus() {
  const inputs = document.querySelectorAll(".js-form-overlay .rt-form__input");
  inputs.forEach((input) => {
    input.addEventListener("focus", (event) => {
      const item = event.currentTarget;
      openAllForms();
      item.closest(".js-form-overlay").classList.add("is-active");
    });
  });
}

document.addEventListener("DOMContentLoaded", openAllForms);
document.addEventListener("DOMContentLoaded", openFormOnFocus);
